import $ from "jquery";

class SummernoteImageUpload {
  constructor(editor) {
    this.editor = editor;
    this.directUploadUrl = '/rails/active_storage/direct_uploads';
  }

  async uploadImages(files) {
    const fileArray = Array.from(files);
    const uploadPromises = fileArray.map(file => this.uploadSingleImage(file));

    try {
      return await Promise.all(uploadPromises);
    } catch (error) {
      this.showError('Failed to upload one or more images');
      throw error;
    }
  }

  async uploadSingleImage(file) {
    if (!this.validateFile(file)) {
      throw new Error(`Invalid file: ${file.name}`);
    }

    this.showUploadProgress(file.name);

    try {
      const formData = new FormData();
      formData.append('image', file);

      const response = await fetch('/portal/summernote/upload', {
        method: 'POST',
        body: formData,
        headers: {
          'X-CSRF-Token': this.getCSRFToken()
        }
      });

      const data = await response.json();

      if (data.success) {
        this.hideUploadProgress();
        this.showSuccess(`Image "${file.name}" uploaded successfully`);
        return data.url;
      } else {
        throw new Error(data.error || 'Upload failed');
      }
    } catch (error) {
      this.hideUploadProgress();
      this.showError(`Failed to upload "${file.name}": ${error.message}`);
      throw error;
    }
  }

  validateFile(file) {
    const maxSize = 5 * 1024 * 1024;
    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'];

    if (file.size > maxSize) {
      this.showError(`File "${file.name}" is too large. Maximum size is 5MB.`);
      return false;
    }

    if (!allowedTypes.includes(file.type)) {
      this.showError(`File "${file.name}" has an invalid format. Allowed formats: JPEG, PNG, GIF, WebP.`);
      return false;
    }

    return true;
  }

  showUploadProgress(filename) {
    const progressHtml = `
      <div class="summernote-upload-progress" data-filename="${filename}">
        <div class="progress-bar">
          <div class="progress-fill"></div>
        </div>
        <span class="progress-text">Uploading "${filename}"...</span>
      </div>
    `;

    try {
      const $editor = $(this.editor);
      const $noteEditor = $editor.closest('.note-editor');
      const $toolbar = $noteEditor.find('.note-toolbar');

      if ($toolbar.length > 0) {
        $toolbar.after(progressHtml);
      } else {
        $editor.before(progressHtml);
      }
    } catch (error) {
      console.warn('Could not show upload progress:', error);
    }
  }

  hideUploadProgress() {
    const progressElements = document.querySelectorAll('.summernote-upload-progress');
    progressElements.forEach(element => element.remove());
  }

  showSuccess(message) {
    this.showNotification(message, 'success');
  }

  showError(message) {
    this.showNotification(message, 'error');
  }

  showNotification(message, type) {
    const notification = document.createElement('div');
    notification.className = `summernote-notification summernote-notification-${type}`;
    notification.textContent = message;
    notification.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      padding: 10px 15px;
      border-radius: 4px;
      color: white;
      font-weight: bold;
      z-index: 9999;
      max-width: 300px;
      word-wrap: break-word;
      ${type === 'success' ? 'background-color: #28a745;' : 'background-color: #dc3545;'}
    `;

    document.body.appendChild(notification);

    setTimeout(() => {
      if (notification.parentNode) {
        notification.parentNode.removeChild(notification);
      }
    }, 3000);
  }

  getCSRFToken() {
    return document.querySelector('meta[name="csrf-token"]').getAttribute('content');
  }
}

window.SummernoteImageUpload = SummernoteImageUpload;
export default SummernoteImageUpload;